var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.processo
    ? _c(
        "div",
        [
          _c(
            "div",
            { staticClass: "analise-automatizada-header" },
            [
              _c("span", [
                _vm._v(
                  "Análise do Processo " + _vm._s(_vm.processo.numeroProcesso)
                )
              ]),
              _c("app-opcoes-header-analise", {
                staticClass: "right",
                attrs: {
                  idProcesso: _vm.processo.id,
                  protocolo: _vm.processo.numeroProtocolo,
                  statusProcesso: _vm.processo.status,
                  numeroProcesso: _vm.processo.numeroProcesso,
                  btnSolicitarInformacao: false,
                  btnRetificacao: false,
                  tipoProcesso: _vm.processo.tipo.codigo,
                  btnNotificarInteressado: false
                }
              })
            ],
            1
          ),
          _c(
            "el-steps",
            {
              attrs: {
                active: _vm.active,
                "finish-status": "success",
                simple: "simple"
              }
            },
            [
              _c("el-step", { attrs: { title: "Informar dados" } }),
              _c("el-step", { attrs: { title: "Confirmar dados" } })
            ],
            1
          ),
          _c(
            "validation-observer",
            { ref: "observer", attrs: { tag: "div" } },
            [
              _vm.active === 2
                ? _c(
                    "div",
                    { staticClass: "step" },
                    [
                      _vm.bytes
                        ? _c("app-pdf-viewer", {
                            attrs: {
                              bytes: _vm.bytes,
                              customStyle: { height: "700px" }
                            }
                          })
                        : _vm._e(),
                      _c("app-radios-tramitacao", {
                        attrs: { radios: _vm.radios, isDecisao: _vm.isDecisao },
                        on: { changeRadio: _vm.changeRadio }
                      })
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "step" },
                    [
                      _c(
                        "el-row",
                        {
                          staticClass: "margin-medium-top",
                          attrs: { gutter: 20 }
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("app-label", {
                                attrs: { label: "Processo:", required: true }
                              }),
                              _c("el-input", {
                                staticClass: "input",
                                attrs: {
                                  value: _vm.dadosAnalise.numeroProcesso,
                                  disabled: true
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 6 } },
                            [
                              _c("app-label", {
                                attrs: {
                                  label: "Tipo de Processo:",
                                  required: true
                                }
                              }),
                              _c("el-input", {
                                staticClass: "input",
                                attrs: {
                                  value: _vm.dadosAnalise.tipoProcesso.nome,
                                  disabled: true
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-label", {
                                attrs: { label: "Interessado:", required: true }
                              }),
                              _c("el-input", {
                                staticClass: "input",
                                attrs: {
                                  value:
                                    _vm.dadosAnalise.nomeRazaoSocialInteressado,
                                  disabled: true
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-row",
                        {
                          staticClass: "margin-medium-top",
                          attrs: { gutter: 20 }
                        },
                        [
                          !_vm.isReurb
                            ? _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("validation-provider", {
                                    attrs: { rules: "required" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("app-label", {
                                                attrs: { label: "Denominação:" }
                                              }),
                                              _c("el-input", {
                                                staticClass: "input",
                                                class: { erro: errors.length },
                                                attrs: {
                                                  name: "denominacao",
                                                  disabled:
                                                    !!_vm.processo.dadosCadastro
                                                      .dados.cadastro.imovel
                                                      .nome ||
                                                    !!_vm.processo.dadosCadastro
                                                      .dados.cadastro.imovel
                                                      .denominacao
                                                },
                                                model: {
                                                  value:
                                                    _vm.dadosAnalise
                                                      .denominacaoImovel,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.dadosAnalise,
                                                      "denominacaoImovel",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dadosAnalise.denominacaoImovel"
                                                }
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      845298632
                                    )
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c("app-label", {
                                attrs: { label: "Município:", required: true }
                              }),
                              _c("el-input", {
                                staticClass: "input",
                                attrs: {
                                  value: _vm.municipiosFormatados,
                                  disabled: true
                                }
                              })
                            ],
                            1
                          ),
                          _vm.isReurb
                            ? _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c("app-label", {
                                    attrs: {
                                      label:
                                        "Área do Georreferenciamento (ha):",
                                      required: true
                                    }
                                  }),
                                  _c("el-input", {
                                    staticClass: "input",
                                    attrs: {
                                      value: _vm.formatDouble(
                                        _vm.dadosAnalise.areaImovel,
                                        4
                                      ),
                                      disabled: true
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.isReurb
                            ? _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c("app-label", {
                                    attrs: {
                                      label: "Perímetro (m):",
                                      required: true
                                    }
                                  }),
                                  _c("el-input", {
                                    staticClass: "input",
                                    attrs: {
                                      value: _vm.formatDouble(
                                        _vm.dadosAnalise.perimetroImovel,
                                        2
                                      ),
                                      disabled: true
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      !_vm.isReurb
                        ? _c(
                            "el-row",
                            {
                              staticClass: "margin-medium-top",
                              attrs: { gutter: 20 }
                            },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c("app-label", {
                                    attrs: {
                                      label: "Recibo do CAR:",
                                      required: false
                                    }
                                  }),
                                  _c("validation-provider", {
                                    attrs: {
                                      rules: _vm.dadosAnalise.numeroReciboCar
                                        ? "car"
                                        : ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(ref) {
                                            var errors = ref.errors
                                            return [
                                              _c("el-input", {
                                                directives: [
                                                  {
                                                    name: "mask",
                                                    rawName: "v-mask",
                                                    value: _vm.customMask,
                                                    expression: "customMask"
                                                  }
                                                ],
                                                staticClass: "input",
                                                class: { erro: errors.length },
                                                attrs: {
                                                  disabled: !!_vm.processo
                                                    .dadosCadastro.dados
                                                    .cadastro.imovel
                                                    .numeroReciboCar,
                                                  name:
                                                    "Número do recibo do CAR"
                                                },
                                                model: {
                                                  value:
                                                    _vm.dadosAnalise
                                                      .numeroReciboCar,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.dadosAnalise,
                                                      "numeroReciboCar",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "dadosAnalise.numeroReciboCar"
                                                }
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "help erro" },
                                                [_vm._v(_vm._s(errors[0]))]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      false,
                                      1151323838
                                    )
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c("app-label", {
                                    attrs: {
                                      label:
                                        "Área do Georreferenciamento (ha):",
                                      required: true
                                    }
                                  }),
                                  _c("el-input", {
                                    staticClass: "input",
                                    attrs: {
                                      value: _vm.formatDouble(
                                        _vm.dadosAnalise.areaImovel,
                                        4
                                      ),
                                      disabled: true
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c("app-label", {
                                    attrs: {
                                      label: "Perímetro (m):",
                                      required: true
                                    }
                                  }),
                                  _c("el-input", {
                                    staticClass: "input",
                                    attrs: {
                                      value: _vm.formatDouble(
                                        _vm.dadosAnalise.perimetroImovel,
                                        2
                                      ),
                                      disabled: true
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._l(_vm.calculosAnalise.tabelas, function(tabela) {
                        return _c(
                          "div",
                          { key: tabela.tipo, staticClass: "tabelas" },
                          [
                            _c("app-divider", {
                              attrs: { label: tabela.nome }
                            }),
                            _c(
                              "el-table",
                              {
                                attrs: {
                                  data: tabela.conteudo,
                                  "max-height": "500"
                                }
                              },
                              [
                                _c(
                                  "div",
                                  { attrs: { slot: "empty" }, slot: "empty" },
                                  [
                                    tabela.tipo ===
                                      "metadadosDaBaseVetorialOficialAtualizada" ||
                                    tabela.tipo ===
                                      "analiseDaBaseVetorialOficial"
                                      ? _c("span", [
                                          _vm._v(
                                            "A geometria do imóvel não sobrepõe com nenhuma camada da base de dados oficiais."
                                          )
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            "A geometria do imóvel não sobrepõe com nenhuma camada da base da BDF."
                                          )
                                        ])
                                  ]
                                ),
                                _c("el-table-column", {
                                  attrs: {
                                    label: tabela.labelColunaPrincipal,
                                    prop: "camada"
                                  }
                                }),
                                _vm._l(tabela.colunasSobreposicoes, function(
                                  coluna
                                ) {
                                  return _c("el-table-column", {
                                    key: coluna.propName,
                                    attrs: { label: coluna.label },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              tabela.tipo ===
                                                "analiseDaBaseDigitalFundiaria" &&
                                              coluna.propName === "nome"
                                                ? _c("div", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row.ano +
                                                            "/" +
                                                            scope.row.processo +
                                                            " - " +
                                                            scope.row
                                                              .interessado
                                                        )
                                                      )
                                                    ])
                                                  ])
                                                : coluna.propName ===
                                                  "informacoes"
                                                ? _c(
                                                    "div",
                                                    [
                                                      scope.row.informacoes
                                                        .length == 0
                                                        ? _c("span", [
                                                            _vm._v("-")
                                                          ])
                                                        : _vm._e(),
                                                      _vm._l(
                                                        scope.row.informacoes,
                                                        function(info) {
                                                          return [
                                                            tabela.tipo ===
                                                            "metadadosDaBaseVetorialOficialAtualizada"
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "info-sobreposicao"
                                                                  },
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          info.valor
                                                                        )
                                                                      )
                                                                    ])
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "info-sobreposicao"
                                                                  },
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          info.nome +
                                                                            " (" +
                                                                            info.valor +
                                                                            ")"
                                                                        )
                                                                      )
                                                                    ])
                                                                  ]
                                                                )
                                                          ]
                                                        }
                                                      )
                                                    ],
                                                    2
                                                  )
                                                : coluna.propName ===
                                                  "porcentagem"
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatDouble(
                                                          scope.row[
                                                            coluna.propName
                                                          ],
                                                          2
                                                        ) || "-"
                                                      )
                                                    )
                                                  ])
                                                : coluna.propName === "area"
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatDouble(
                                                          scope.row[
                                                            coluna.propName
                                                          ],
                                                          4
                                                        ) || "-"
                                                      )
                                                    )
                                                  ])
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row[
                                                          coluna.propName
                                                        ] || "-"
                                                      )
                                                    )
                                                  ])
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                })
                              ],
                              2
                            )
                          ],
                          1
                        )
                      }),
                      _c(
                        "div",
                        { staticClass: "campo" },
                        [
                          _c("app-label", {
                            attrs: { label: "Observações", required: false }
                          }),
                          !_vm.isLoading
                            ? _c("app-editor-texto", {
                                ref: "textoObservacoes",
                                staticClass: "input",
                                on: { onTextChange: _vm.onChangeObservacoes },
                                model: {
                                  value: _vm.dadosAnalise.observacoes,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.dadosAnalise,
                                      "observacoes",
                                      $$v
                                    )
                                  },
                                  expression: "dadosAnalise.observacoes"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _c("validation-provider", {
                        staticClass: "campo",
                        attrs: { rules: "required", tag: "div" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: { label: "Conclusão" }
                                  }),
                                  !_vm.isLoading
                                    ? _c("app-editor-texto", {
                                        ref: "textoConclusao",
                                        staticClass: "input",
                                        class: { erro: errors.length },
                                        on: {
                                          onTextChange: _vm.onChangeConlusao
                                        },
                                        model: {
                                          value: _vm.dadosAnalise.conclusao,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.dadosAnalise,
                                              "conclusao",
                                              $$v
                                            )
                                          },
                                          expression: "dadosAnalise.conclusao"
                                        }
                                      })
                                    : _vm._e(),
                                  _c("span", { staticClass: "help erro" }, [
                                    _vm._v(_vm._s(errors[0]))
                                  ])
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          1089150402
                        )
                      }),
                      _vm._t("anexoMapas")
                    ],
                    2
                  )
            ]
          ),
          _c("app-buttons-cadastro", {
            attrs: {
              isUltimoPasso: _vm.isLastStep,
              isPrimeiroPasso: !_vm.isLastStep,
              showButtonSalvar: !_vm.isLastStep,
              showButtonCancelar: !_vm.isLastStep,
              showButtonDownload: _vm.isLastStep,
              showButtonAnaliseManual: !_vm.isLastStep,
              showButtonProximo: !_vm.isLastStep,
              labelButtonAnaliseManual: "Análise manual"
            },
            on: {
              proximo: _vm.proximo,
              voltar: function($event) {
                return _vm.$emit("setActive", 1)
              },
              finalizar: _vm.finalizar,
              cancelar: _vm.cancelar,
              salvar: _vm.salvar,
              changeAnalise: _vm.changeAnalise,
              download: _vm.downloadPdf
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-588f4902", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-588f4902","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/AnaliseAutomatizada.vue
// module id = null
// module chunks = 